module.exports = __webpack_public_path__ + "static/minyadi-extrude-1e5972f7a7969cbed14dc835a738a34a.jpg";